<template>
    <div>
        <b-alert variant="dark" :show="enfermariaSelecionada != '' ? true : false" class="text-center">
            <strong>Filtrando por Enfermaria:</strong> {{enfermariaSelecionada}}
        </b-alert>

        <b-alert variant="dark" :show="filtroCodEnfermaria != '' ? true : false" class="text-center">
            <strong>Filtrando por Código de Enfermaria:</strong> {{filtroCodEnfermaria}}
        </b-alert>

        <b-alert variant="success" :show="listagemFiltradaStatus == 0 ? true : false" class="text-center">
            <strong>Leitos Livres</strong>
        </b-alert>

        <b-alert variant="secondary" :show="listagemFiltradaStatus == 1 ? true : false" class="text-center">
            <strong>Leitos Ocupados</strong>
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 2 ? true : false" class="text-center">
            <strong>Leitos Impedidos</strong>
        </b-alert>

        <b-alert variant="info" :show="listagemFiltradaStatus == 3 || listagemFiltradaStatus == 4 ? true : false" class="text-center">
            <strong>Leitos Cedidos</strong>
        </b-alert>

        <b-alert variant="warning" :show="listagemFiltradaStatus == 13 ? true : false" class="text-center">
            <strong>Leitos Reservados</strong>
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 5 ? true : false" class="text-center">
            <i class="fa fa-ban" aria-hidden="true"></i><strong> Impedir Leito</strong> (Escolha o leito a ser impedido)
        </b-alert>

        <b-alert variant="success" :show="listagemFiltradaStatus == 6 ? true : false" class="text-center">
            <i class="fa fa-check" aria-hidden="true"></i><strong> Liberar Leito</strong> (Escolha o leito a ser liberado)
        </b-alert>

        <b-alert variant="secondary" :show="listagemFiltradaStatus == 7 ? true : false" class="text-center">
            <i class="fa fa-info-circle" aria-hidden="true"></i><strong> Tranferir Leito - ETAPA 1</strong> (Escolha o leito ocupado a ser transferido)
        </b-alert>

        <b-alert variant="success" :show="listagemFiltradaStatus == 8 ? true : false" class="text-center">
            <i class="fa fa-info-circle" aria-hidden="true"></i><strong> Tranferir Leito - ETAPA 2</strong> (Escolha o leito livre a para a transferência)
        </b-alert>

        <b-alert variant="info" :show="listagemFiltradaStatus == 9 ? true : false" class="text-center">
            <i class="fa fa-share" aria-hidden="true"></i><strong> Ceder Leito</strong> (Escolha o leito a ser cedido para a Central de Regulação)
        </b-alert>

         <b-alert variant="warning" :show="listagemFiltradaStatus == 14 ? true : false" class="text-center">
            <strong>Reservar Leito (Escolha o leito a ser reservado)</strong>
        </b-alert>

        <b-alert variant="secondary" :show="listagemFiltradaStatus == 10 ? true : false" class="text-center">
            <i class="fa fa-money" aria-hidden="true"></i><strong> Gerar AIH</strong> (Escolha o leito ocupado para a geração de AIH)
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 11 ? true : false" class="text-center">
            <strong>Notificar Longa Permanência</strong> (Escolha o leito ocupado a ser notificado)
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 12 ? true : false" class="text-center">
            <strong>Leitos com Longa Permanência</strong> (Clique para visualizar e/ou editar)
        </b-alert>

         <b-alert variant="danger" :show="listagemFiltradaStatus == 15 ? true : false" class="text-center">
            <strong>Notificar Suspeita de COVID-19</strong> (Escolha o leito ocupado a ser notificado)
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 16 ? true : false" class="text-center">
            <strong>Leitos suspeitos de COVID-19</strong> (Clique para visualizar e/ou editar)
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 20 ? true : false" class="text-center">
            <strong>Leitos ocupados</strong> (Clique para acompanhar)
        </b-alert>

        <b-alert variant="danger" :show="listagemFiltradaStatus == 21 ? true : false" class="text-center">
            <strong>Leitos ocupados +24h</strong>
        </b-alert>

        <b-alert variant="secondary" :show="listagemFiltradaStatus == 22 ? true : false" class="text-center">
            <strong>Leitos com pacientes sem identificação</strong> (clique para atualizar)
        </b-alert>

    </div>
</template>

<script>
export default {
    computed: {
        listagemFiltradaStatus () {
            // Filtros inseridos pelas ações da barra lateral PARA LISTAR SOMENTE DO TIPO ESPECIFICADO
            // SIDEBARLEFT => 0=Livres, 1=Ocupados, 2=Impedidos, 3=Cedidos,
            // 11=ocupados-longap(no clique: Notifica LongaP), 12=ocupados+longap(no clique: Editar LongaP) 13=Reservados

            // SIDEBARRIGHT => 5=livres(no clique: Impedir Leito), 6=impedidos (no clique: Liberar Leitos -SidebarRight),
            // 7=ocupados(no clique: Transferir Leito - Etapa 1), 8=livres (no clique:  Transferir Leito - Etapa 2)
            // 9=livres(no clique: Ceder Leito), 10=ocupados(no clique: Gerar AIH), 14=Livres(no clique: Reservar Leito)
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        listagemEnfermarias () {
            return this.$store.getters['filtro/getListagemEnfermarias']
        },
        enfermariaSelecionada () {
            return this.$store.getters['filtro/getEnfermariaSelecionada']
        },
        filtroCodEnfermaria () {
            return this.$store.getters['filtro/getFiltroCodEnfermaria']
        },
    }
}
</script>
